import styled from "styled-components";
import theme from "../common/theme";
import { P } from "./Typography";
import { useState } from "react";
import { ButtonBase } from "./Buttons";
import { FaEllipsisV } from "react-icons/fa";
import { useEffect } from "react";

export const Table = styled.table`
    font-family: "Roboto Condensed";
    font-size: 14px;
    border-collapse: collapse;
    border: 1px solid #d9d9d9;
    user-select: none;
    `

export const TableHeader = styled.th`
    background-color: #000;
    color: #fff;
    font-weight: 700;
    padding: 1rem;
    text-align: left;
    border: 1px solid #333;
    `

export const TableData = styled.td`
    padding: 1rem;
    border: 1px solid ${theme.palette.borderDark};    
`

export const TableDataLast = styled(TableData)`
    padding-right: 0;
`

export const TableDataUnderline = styled(TableData)`
    text-decoration: underline;
    `

export const TableRow = styled.tr`
    cursor: pointer;
    &:nth-child(even) {
        background-color: #f4f4f4;
    }
    
    &:hover {
        background: ${theme.palette.border};
    }
    
    `

export const TableFooter = styled.footer`
    border: 1px solid #d9d9d9;
    border-top: none;
    margin-top: -1rem;
    display: flex;
    background-color: #f4f4f4;
    justify-content: flex-end;
    align-items: center;
`

export const Menu = styled.div`
    float: right;
    align-self: center;
    display: inline-block;
    position: relative;
    cursor: pointer;
`

export const MenuContent = styled.div`
    position: absolute;
    display: none;
    // min-width: 350px;
    right: 0;
    padding: 0.25rem;
    background-color: #f9f9f9;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 100;
    min-width: 150px;
    gap: 0.25rem;
    flex-direction: column;
`

export const MenuItem = styled.button`
    flex: 1;
    outline: none;
    display: flex;
    padding: 0.5rem 1rem;
    align-items: center;
    opacity: ${props => props.disabled ? 0.7 : 1};
    cursor: ${props => props.disabled ? 'default' : 'pointer'};
    border: none;
    &:hover {
        background: ${theme.palette.border};
    }
`

export const MenuLauncher = styled(ButtonBase)`
    padding: 0 1rem;
`

const StyledIcon = styled(FaEllipsisV)`
    transition: all 100ms ease-in-out;
    border: 1px solid transparent;
    padding: 0.125rem;
    color: #222;

    &:hover {
        background: ${theme.palette.light};
        border: 1px solid ${theme.palette.light};
        border-radius: 1rem;
        color: ${theme.palette.dark};
    }
    
`

export const TableMenu = ({ children }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const hideMenu = () => setVisible(false);
        window.addEventListener('click', hideMenu);

        return () => window.removeEventListener('click', hideMenu);
    }, []);

    const onClick = (e) => {
        e.stopPropagation();
        setVisible(!visible);
    }

    return (
        <Menu>
            <MenuLauncher onClick={onClick}>
                <StyledIcon />
            </MenuLauncher>
            <MenuContent style={{ display: visible ? 'flex' : 'none' }}>
                {children}
            </MenuContent>
        </Menu>
    );
};